
import { defineComponent, ref, Ref, inject } from "vue";
import useSaveAndContinue from "@/composables/useSaveAndContinue";
import { onBoardingSaveContinueRef } from "@/onboarding/Refs";
import { UrlProperties } from "@/types";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";
import { getEditorUrlParam } from "@/composables/useParseURL";

export default defineComponent({
  name: "SaveAndContinue",
  setup() {

    const loading = ref(false);
    const saveAndContinue = async () => {
      // Ensure the design has been saved before continuing
      if (!getEditorUrlParam('hash')) {
        store.dispatch(ActionTypes.SET_MODAL, "nameAndContinue");
      } else {
        loading.value = true;
        loading.value = await useSaveAndContinue();
      }
    };

    const urlProperties = inject<Ref<UrlProperties>>("urlProperties");

    return {
      onBoardingSaveContinueRef,
      loading,
      saveAndContinue,
      labelType: urlProperties && urlProperties.value && urlProperties.value.labelType ? urlProperties.value.labelType : "",
    };
  },
});
